import { createSlice } from '@reduxjs/toolkit';

export type ToastVariant = 'error' | 'success';

interface ToastState {
  visible: boolean;
  message: string;
  variant: ToastVariant;
}

const initialState: ToastState = {
  visible: false,
  message: '',
  variant: 'error',
};

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showError: (state, action: { payload: string }) => {
      state.visible = true;
      state.message = action.payload;
      state.variant = 'error';
    },
    showSuccess: (state, action: { payload: string }) => {
      state.visible = true;
      state.message = action.payload;
      state.variant = 'success';
    },
    hideToast: (state) => {
      state.visible = false;
      state.message = '';
    },
  },
});

export const { showError, showSuccess, hideToast } = toastSlice.actions;
export const toastReducer = toastSlice.reducer;
